import styled from 'styled-components'

export const Container = styled.div`
  height: 100%;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  overflow: hidden;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  img {
    width: 500px;
    height: 500px;
  }

  h1 {
    color: #263238;
    font-weight: normal;
    font-size: 24px;

    a {
      font-weight: bold;
      text-decoration: none;
      color: #0d6efd;
      text-decoration: none;
    }

    span {
      font-weight: bold;
      text-decoration: none;
      color: #0d6efd;
    }
  }
`
